import {
  DocumentData,
  DocumentReference,
  FirestoreDataConverter,
} from "firebase/firestore";

type WithIdData = {
  id: string;
  ref: DocumentReference;
} & DocumentData;

export const withIdConverter: FirestoreDataConverter<WithIdData> = {
  toFirestore({ id, ref, ...data }): DocumentData {
    return data;
  },
  fromFirestore(snapshot, options): WithIdData {
    const data = snapshot.data(options);
    return {
      ...data,
      id: snapshot.id,
      ref: snapshot.ref,
    };
  },
};
